module.exports = __webpack_public_path__ + "static/media/twitter2.bbb67b5a.svg";